import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-modal-dialog',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

    @Input() show = false;
    @Input() title = '';
    @Input() width = 480;
    @Input() closeOnBackdrop = true;
    @Output() closed = new EventEmitter<void>();

    close(): void {
        this.closed.emit();
    }

    onOverlayClick(event: MouseEvent): void {
        if (this.closeOnBackdrop && event.target === event.currentTarget) {
            this.close();
        }
    }
}
